// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2i9Ni","sendOtp":"AuthorizeToLogin_sendOtp__sFqzL"};